import { useQuery } from '@tanstack/react-query';

import { catalogCompanySourceMapApi } from 'api/inventory/catalogCompanySourceMap';

export const COMPANY_SOURCES_QUERY_KEY = 'catalogCompanySources';

async function fetchCompanySources() {
    const response = await catalogCompanySourceMapApi.getCompanySourceOptions();
    if (!response?.status) {
        throw new Error(response?.msg ?? 'Failed to fetch company sources');
    }
    return response?.data?.companySources ?? [];
}

/**
 * @param {Array<{ id: number, code: string, displayName: string }>} companySources
 * @returns {Array<{ text: string, value: number }>}
 */
export function mapCompanySourcesToSelectOptions(companySources) {
    return companySources.map((item) => ({ text: item.displayName, value: item.id }));
}

/**
 * Fetches all company sources from the catalog API.
 *
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 * @returns {import('@tanstack/react-query').UseQueryResult<Array<{ id: number, code: string, displayName: string }>, Error>}
 */
export function useCompanySourceOptionsQuery({ enabled = true } = {}) {
    return useQuery({
        queryKey: [COMPANY_SOURCES_QUERY_KEY],
        enabled,
        queryFn: fetchCompanySources,
        staleTime: 15 * 60_000,
        gcTime: 30 * 60_000,
    });
}
